import { FetchResult, gql } from 'apollo-boost';
import { IUserGroup } from '../../../models/user-group';
import { MultiError } from '../../../types/multi-error';
import { graphqlClient } from '../../graphql-client';

const QUERY = gql`
    query GetUserGroup($uid: String!) {
        user_group(uid: $uid) {
            uid,
            groupId: group_id,
            title,
            description,
            address,
            city,
            state,
            zipCode: zipcode,
            groupType: group_type,
            organizationType: organization_type,
            startDate: start_date,
            endDate: end_date,
            domain,
            domainForConfirmation: domain_for_confirmation_only,
            nonOrgEmailAllowed: non_org_emails_allowed,
            educatorConfirmationRequired: educator_confirmation_required,
            emailConfirmationRequired: email_confirmation_required,
            notificationSentOnAdd: notification_sent_on_add,
            notificationToAdminOnJoin: notification_to_admin_on_join,
            dontAddUsersToEmailLists: dont_add_users_to_email_lists,
            enabled,
            default,
            createdAt: created_at,
            limitContentByAge: limit_content_by_age,
            progressSync: progress_sync,
            unlisted,
            unsubscribed,
            contactEmail: contact_email,
            ptaContactEmail: pta_contact_email,
            fundingActivated: funding_activated,
            fundingActivatedAt: funding_activated_at,
            discountCode: discount_code,
            numSupporters: num_supporters,
            numSubscribedSupporters: num_subscribed_supporters,
            HIPAAEnforced: HIPAA_enforced,
            sharingEnabled: sharing_enabled,
            journalSubmissions: journal_submissions,
            journalPrompt: journal_prompt,
            activityModeSwitchingAllowed: activity_mode_switching_allowed,
            userCount: user_count,
            inviteCount: invite_count,
            maxAgeRating: max_age_rating,
            maxUsers: max_users,
            inviteCode: invite_code,
            inviteCodeExpirationDate: invite_code_expiration_date,
            rewardSchema: reward_schema_ref,
            userPlan: user_plan_ref,
            allowsInterstitials: allows_interstitials,
            allowsInterstitialsOnly: allows_interstitials_only,
            hideBookmarks: hide_bookmarks,
            useOnlyBookmarksInTraining: use_only_bookmarks_in_training,

            owner {
              uid,
              email,
              firstName: first_name,
              lastName: last_name
            },
            createdBy: created_by {
              uid,
              email,
              firstName: first_name,
              lastName: last_name,
              role
            },            

            curriculums {
                uid,
                name,
                description,
                available,
                minAgeRating: min_age_rating
            },

            narratives {
                uid,
                title,
                available
            },

            userProfile: profile {
                uid,
                name
            }

        }
    }
`;

export async function getUserGroup(uid: string): Promise<IUserGroup> {
    const result: FetchResult<{ user_group: IUserGroup }> = await graphqlClient.query({
        query: QUERY,
        variables: { uid },
        errorPolicy: 'all',
    });

    if(!result.data || result.errors && result.errors.length) {
        throw new MultiError(result.errors || ['Unknown error']);
    }

    return result.data.user_group;
}
